import messages from '../../messages';

export const { SAST, SAST_HAS_ERROR, SAST_IS_LOADING } = messages;
